module.exports = __webpack_public_path__ + "img/floor_UG1.5a8c28cf.svg";